(function () {
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mainNav = document.querySelector('[data-main-nav]');

  if (menuToggle && mainNav) {
    menuToggle.addEventListener('click', function () {
      var isOpen = mainNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterSidebar = document.querySelector('[data-filter-sidebar]');
  var filterClose = document.querySelector('[data-filter-close]');

  function closeFilters() {
    if (filterSidebar) filterSidebar.classList.remove('is-open');
  }

  if (filterToggle && filterSidebar) {
    filterToggle.addEventListener('click', function () {
      filterSidebar.classList.add('is-open');
    });
  }

  if (filterClose) {
    filterClose.addEventListener('click', closeFilters);
  }

  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  var slides = Array.prototype.slice.call(document.querySelectorAll('[data-product-slide]'));
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-thumb]'));
  var optionInputs = Array.prototype.slice.call(document.querySelectorAll('.swatch-choice input, .option-pill input'));

  function syncSelectedOptions() {
    optionInputs.forEach(function (input) {
      var label = input.closest('.swatch-choice, .option-pill');
      if (label) label.classList.toggle('is-selected', input.checked);
    });
  }

  optionInputs.forEach(function (input) {
    input.addEventListener('change', syncSelectedOptions);
  });

  syncSelectedOptions();

  function getVariantOptions(variant) {
    if (Array.isArray(variant.options)) return variant.options;

    return [variant.option1, variant.option2, variant.option3].filter(function (option) {
      return option !== null && option !== undefined;
    });
  }

  function getVariantMediaId(variant) {
    if (!variant) return null;
    if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
    if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
    return null;
  }

  function initProductForm(form) {
    var productJson = form.querySelector('[data-product-json]');
    var variantInput = form.querySelector('[data-product-variant-id]');
    var addButton = form.querySelector('[data-add-to-cart]');
    var addButtonLabel = form.querySelector('[data-add-to-cart-label]');
    var status = form.querySelector('[data-product-status]');
    var formOptionInputs = Array.prototype.slice.call(form.querySelectorAll('[data-option-position]'));
    var productData = null;

    if (!productJson || !variantInput || !addButton) return;

    try {
      productData = JSON.parse(productJson.textContent);
    } catch (error) {
      return;
    }

    function getSelectedOptions() {
      var selectedOptions = [];

      formOptionInputs.forEach(function (input) {
        if (!input.checked) return;
        selectedOptions[Number(input.getAttribute('data-option-position')) - 1] = input.value;
      });

      return selectedOptions;
    }

    function findVariantByOptions(selectedOptions) {
      if (!selectedOptions.length) {
        return productData.variants.find(function (variant) {
          return String(variant.id) === String(variantInput.value);
        }) || productData.variants[0];
      }

      return productData.variants.find(function (variant) {
        var variantOptions = getVariantOptions(variant);

        return selectedOptions.every(function (option, index) {
          return option === undefined || String(variantOptions[index]) === String(option);
        });
      });
    }

    function setButtonState(variant) {
      var addText = addButton.getAttribute('data-add-text') || 'Add to cart';
      var soldOutText = addButton.getAttribute('data-sold-out-text') || 'Sold out';
      var unavailableText = addButton.getAttribute('data-unavailable-text') || 'Unavailable';
      var label = addText;
      var disabled = false;

      if (!variant) {
        label = unavailableText;
        disabled = true;
      } else if (!variant.available) {
        label = soldOutText;
        disabled = true;
      }

      variantInput.value = variant ? variant.id : '';
      addButton.disabled = disabled;
      if (addButtonLabel) addButtonLabel.textContent = label;

      if (status) {
        status.hidden = !disabled;
        status.textContent = disabled ? label : '';
      }
    }

    function updateProductUrl(variant) {
      if (!variant || !window.history || !window.history.replaceState) return;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function updateProductMedia(variant) {
      var mediaId = getVariantMediaId(variant);
      if (mediaId) activateMedia(mediaId);
    }

    function updateProductForm() {
      var selectedVariant = findVariantByOptions(getSelectedOptions());

      setButtonState(selectedVariant);
      updateProductUrl(selectedVariant);
      updateProductMedia(selectedVariant);
    }

    formOptionInputs.forEach(function (input) {
      input.addEventListener('change', updateProductForm);
    });

    updateProductForm();
  }

  Array.prototype.slice.call(document.querySelectorAll('.product-form')).forEach(initProductForm);

  function decorateProductDescriptionLists() {
    Array.prototype.slice.call(document.querySelectorAll('.product-info, .product-info__description')).forEach(function (description) {
      Array.prototype.slice.call(description.querySelectorAll('ul')).forEach(function (list) {
        if (list.closest('.product-accordion')) return;
        list.classList.add('product-info__feature-list');
      });

      Array.prototype.slice.call(description.querySelectorAll('p')).forEach(function (paragraph) {
        if (paragraph.closest('.product-accordion')) return;
        if (paragraph.getAttribute('data-gogoyarn-list-checked') === 'true') return;
        paragraph.setAttribute('data-gogoyarn-list-checked', 'true');

        var htmlWithLineBreaks = paragraph.innerHTML.replace(/<br\s*\/?>/gi, '\n');
        var temp = document.createElement('div');
        temp.innerHTML = htmlWithLineBreaks;

        var text = (temp.textContent || '').replace(/\r/g, '').replace(/\u00a0/g, ' ').trim();
        var lines = text.split('\n').map(function (line) {
          return line.trim();
        }).filter(Boolean);
        var bulletLines = lines.filter(function (line) {
          return /^[•·▪]\s*/.test(line);
        });

        if (bulletLines.length < 2) return;

        var list = document.createElement('ul');
        list.className = 'product-info__feature-list';

        bulletLines.forEach(function (line) {
          var item = document.createElement('li');
          item.textContent = line.replace(/^[•·▪]\s*/, '');
          list.appendChild(item);
        });

        paragraph.parentNode.replaceChild(list, paragraph);
      });
    });
  }

  decorateProductDescriptionLists();

  var swatchMap = {
    pink: '#f8bfd0',
    rose: '#f4a7ba',
    blush: '#ffd6df',
    mint: '#bee8d4',
    green: '#93d7ae',
    cream: '#fff0d4',
    ivory: '#fff8ef',
    white: '#ffffff',
    black: '#2f282b',
    brown: '#a06f55',
    blue: '#9ed4f6',
    yellow: '#f8df82',
    purple: '#cdb7f5',
    lavender: '#cdb7f5',
    red: '#ef6f7f',
    orange: '#f4a65f',
    gray: '#c9c4c1',
    grey: '#c9c4c1',
    奶白: '#fff8ef',
    粉: '#f8bfd0',
    薄荷: '#bee8d4',
    绿: '#93d7ae',
    蓝: '#9ed4f6',
    黄: '#f8df82',
    紫: '#cdb7f5',
    灰: '#c9c4c1',
    棕: '#a06f55'
  };

  Array.prototype.slice.call(document.querySelectorAll('[data-swatch-value]')).forEach(function (swatch) {
    var raw = (swatch.getAttribute('data-swatch-value') || '').trim();
    var normalized = raw.toLowerCase();
    var color = null;

    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(raw)) {
      color = raw;
    } else {
      Object.keys(swatchMap).some(function (key) {
        if (normalized.indexOf(key.toLowerCase()) !== -1 || raw.indexOf(key) !== -1) {
          color = swatchMap[key];
          return true;
        }
        return false;
      });
    }

    if (color) swatch.style.background = color;
  });

  function activateMedia(id) {
    slides.forEach(function (slide) {
      slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === id);
    });
    thumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === id);
    });
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      activateMedia(thumb.getAttribute('data-media-id'));
    });
  });

  var zoomModal = document.querySelector('[data-zoom-modal]');
  var zoomImage = document.querySelector('[data-zoom-image]');
  var zoomClose = document.querySelector('[data-zoom-close]');

  slides.forEach(function (slide) {
    slide.addEventListener('click', function () {
      if (!zoomModal || !zoomImage) return;
      var image = slide.querySelector('img');
      if (!image) return;
      zoomImage.src = image.currentSrc || image.src;
      zoomImage.alt = image.alt || '';
      zoomModal.hidden = false;
      document.body.style.overflow = 'hidden';
    });
  });

  function closeZoom() {
    if (!zoomModal) return;
    zoomModal.hidden = true;
    document.body.style.overflow = '';
  }

  if (zoomClose) {
    zoomClose.addEventListener('click', closeZoom);
  }

  if (zoomModal) {
    zoomModal.addEventListener('click', function (event) {
      if (event.target === zoomModal) closeZoom();
    });
  }

  function getDirectText(element) {
    return Array.prototype.slice.call(element.childNodes).map(function (node) {
      return node.nodeType === Node.TEXT_NODE ? node.nodeValue : '';
    }).join(' ');
  }

  function normalizeReviewText(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function decorateReviewCopy(root) {
    if (!root) return;

    Array.prototype.slice.call(root.querySelectorAll('*')).forEach(function (element) {
      var directText = normalizeReviewText(getDirectText(element));
      var leafText = element.children.length ? '' : normalizeReviewText(element.textContent);
      var text = directText || leafText;

      if (!text) return;

      if (text === 'customer review' || text === 'customer reviews') {
        element.classList.add('gogoyarn-reviews__native-title');
      }

      if (text.indexOf('be the first person to write a comment') !== -1) {
        element.classList.add('gogoyarn-reviews__native-empty-copy');
      }

      if (text === 'no items found') {
        element.classList.add('gogoyarn-reviews__native-no-items');
      }

      if (text.indexOf('write a comment') !== -1 && /^(a|button)$/i.test(element.tagName)) {
        element.classList.add('gogoyarn-reviews__native-action');
      }
    });
  }

  Array.prototype.slice.call(document.querySelectorAll('[data-gogoyarn-reviews-app]')).forEach(function (root) {
    decorateReviewCopy(root);

    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        decorateReviewCopy(root);
      });

      observer.observe(root, { childList: true, subtree: true, characterData: true });
    }

    window.setTimeout(function () {
      decorateReviewCopy(root);
    }, 500);
  });

function isInsideThemeProductForm(element){return!!element.closest(".product-info, .product-form, [data-product-form], [data-mobile-sticky-cart], .mobile-sticky-cart, .site-header, .cart-drawer, .gogoyarn-reviews")}

  function hideFloatingCtaElement(element) {
    if (!element || element.closest('[data-gogoyarn-hidden-floating-cta]')) return;

    var target = element;
    var current = element.parentElement;

    for (var depth = 0; current && current !== document.body && depth < 5; depth += 1) {
      var text = normalizeReviewText(current.textContent);
      var rect = current.getBoundingClientRect();
      var looksLikeLeftRail = rect.left < 260 && rect.width <= 460 && rect.height <= 320;

      if (looksLikeLeftRail && (text.indexOf('ready to make?') !== -1 || text.indexOf('add to cart') !== -1 || /[¥$€£]\s*\d/.test(text))) {
        target = current;
      }

      current = current.parentElement;
    }

    target.classList.add('gogoyarn-hidden-floating-cta');
    target.setAttribute('data-gogoyarn-hidden-floating-cta', 'true');
  }

  function hideOrphanFloatingCta() {
    if (!document.body.classList.contains('template-product')) return;

    Array.prototype.slice.call(document.querySelectorAll('body *')).forEach(function (element) {
      if (element.closest('[data-gogoyarn-hidden-floating-cta]')) return;
      if (isInsideThemeProductForm(element)) return;

      var directText = normalizeReviewText(getDirectText(element));
      var leafText = element.children.length ? '' : normalizeReviewText(element.textContent);
      var text = directText || leafText;
      var rect = element.getBoundingClientRect();
      var isLeftOrphan = rect.left < 220 && rect.top > 80;

      if (text === 'ready to make?' || (isLeftOrphan && (text === 'add to cart' || /^[¥$€£]\s*\d/.test(text)))) {
        hideFloatingCtaElement(element);
      }
    });
  }

  hideOrphanFloatingCta();

  if (window.MutationObserver) {
    var floatingCtaObserver = new MutationObserver(function () {
      hideOrphanFloatingCta();
    });

    floatingCtaObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  window.setTimeout(hideOrphanFloatingCta, 500);
  window.setTimeout(hideOrphanFloatingCta, 2000);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeZoom();
      closeFilters();
    }
  });
})();
